/**
 * Giriş yapmış üyelere özel alan — URL öneki: /member-area/...
 * @typedef {{ slug: string, title: string, subtitle: string, placeholderBody: string }} MemberSectionMeta
 */

/** @type {Record<string, MemberSectionMeta>} */
const BY_SLUG = {
    bulletins: {
        slug: 'bulletins',
        title: 'Bültenler',
        subtitle: 'Kulüp bülten ve duyuruları',
        placeholderBody:
            'Bu bölümün içeriği hazırlanıyor. PDF / web bültenleri burada listelenecek.',
    },
    members: {
        slug: 'members',
        title: 'Üyeler',
        subtitle: 'Üye rehberi',
        placeholderBody:
            'Üye listesi ve iletişim bilgileri API veya yönetim paneli bağlandığında burada yer alacak.',
    },
    'event-calendar': {
        slug: 'event-calendar',
        title: 'Etkinlik Takvimi',
        subtitle: 'Kulüp etkinlikleri',
        placeholderBody:
            'Toplantı ve sosyal etkinlik takvimi entegrasyonu sonrası bu sayfa güncellenecek.',
    },
    galleries: {
        slug: 'galleries',
        title: 'Galeriler',
        subtitle: 'Fotoğraf ve albümler',
        placeholderBody:
            'Etkinlik fotoğrafları ve albümler burada toplanacak.',
    },
    'fellowship-groups': {
        slug: 'fellowship-groups',
        title: 'Ocakbaşı Grupları',
        subtitle: 'Grup bilgileri',
        placeholderBody:
            'Ocakbaşı gruplarına ait bilgiler ve bağlantılar eklenecek.',
    },
};

/**
 * @param {string | undefined} slug
 * @returns {MemberSectionMeta | null}
 */
export function getMemberSectionBySlug(slug) {
    if (!slug || !BY_SLUG[slug]) return null;
    return BY_SLUG[slug];
}

/**
 * Üst beyaz şeritte (giriş sonrası) “Üye alanı” açılır menüsü linkleri.
 * @type {{ labelKey: string, to: string }[]}
 */
export const MEMBER_AREA_NAV_ITEMS = [
    {
        labelKey: 'memberArea.nav.bulletins',
        to: `/member-area/${BY_SLUG.bulletins.slug}`,
    },
    {
        labelKey: 'memberArea.nav.members',
        to: `/member-area/${BY_SLUG.members.slug}`,
    },
    {
        labelKey: 'memberArea.nav.calendar',
        to: `/member-area/${BY_SLUG['event-calendar'].slug}`,
    },
    {
        labelKey: 'memberArea.nav.galleries',
        to: `/member-area/${BY_SLUG.galleries.slug}`,
    },
    {
        labelKey: 'memberArea.nav.ocakbasi',
        to: `/member-area/${BY_SLUG['fellowship-groups'].slug}`,
    },
];
